let prefix = '/api/department_indicators';

function getID(id){
    return window.axios.get(prefix+'/getIndiId/'+id);
}
function getIDNot(id){
    return window.axios.get(prefix+'/getIndiNotId/'+id);
}
function store(data){
    return window.axios.post(prefix+'/store', data);
}
function update(id, data){
    return window.axios.put(prefix+'/'+id, data);
}
function deleteDeptIndi(id){
    return window.axios.delete(prefix+'/'+id);
}

export default {
    getID,
    getIDNot,
    store,
    update,
    deleteDeptIndi,
}